import { Box } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Bar } from 'react-chartjs-2'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

const options = {
  maintainAspectRatio: false,
  aspectRatio: 1,
  indexAxis: 'y',
  elements: {
    bar: {
      borderWidth: 2,
    },
  },
  responsive: true,
  plugins: {
    legend: {
      position: 'bottom',
      labels: { color: 'rgba(255,255,255,0.72)' },
    },
    title: {
      display: false,
      text: '',
    },
    datalabels: {
      display: false,
    },
  },
  scales: {
    x: {
      grid: { color: 'rgba(255,255,255,0.06)' },
      ticks: {
        color: 'rgba(255,255,255,0.72)',
        callback: (val) => {
          return val + '%'
        },
      },
    },
    y: {
      grid: { color: 'rgba(255,255,255,0.06)' },
      ticks: { color: 'rgba(255,255,255,0.72)' },
    },
  },
}
export default function BarChart({ bardata }) {
  const [labels, setlabels] = useState([])
  const [datavalue1, setDatavalue1] = useState([])
  const [datavalue2, setDatavalue2] = useState([])
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  useEffect(() => {
    let d1 = []
    let d2 = []
    let d3 = []
    if (bardata) {
      bardata.forEach((e) => {
        d1.push(e.classification)
        d2.push(parseInt(e.objectif))
        d3.push(parseFloat(e.reel < 0 ? e.reel * -1 : e.reel).toFixed(2))
      })
    }
    setlabels(d1)
    setDatavalue1(d2)
    setDatavalue2(d3)
  }, [bardata])
  const data = {
    labels,
    datasets: [
      {
        label: t('finance.monBudget.objectifLabel'),
        data: datavalue1,
        borderColor: '#4870ab',
        backgroundColor: '#4870ab',
      },
      {
        label: t('finance.monBudget.reelLabel'),
        data: datavalue2,
        borderColor: '#adb5bd',
        backgroundColor: '#adb5bd',
      },
    ],
  }
  return (
    <Box
      height={250}
      width={'100%'}
      sx={{
        bgcolor: 'rgba(255,255,255,0.07)',
        border: '1px solid rgba(255,255,255,0.1)',
        borderRadius: 2,
        p: 2,
      }}
    >
      <Box sx={{ color: '#fff', fontWeight: 850, fontSize: 15 }}>{t('finance.monBudget.objectiveVsReal')}</Box>
      <Box sx={{ color: 'rgba(255,255,255,0.55)', fontSize: 12, mb: 1 }}>
        {t('finance.monBudget.objectiveVsRealSubtitle')}
      </Box>
      <Bar options={options} data={data} />
    </Box>
  )
}
